import http from "../helpers/http-common";

class UsersDataService {
    getAll(params) {
        return http.post("/users/all", params);
    }

    getBeautifulUsers(params) {
        return http.post('/users/beautifulUsers', params);
    }

    reviewBeautifulUsers(params) {
        return http.post('/users/reviewBeautifulUsers', params);
    }

    getUsersUpdatesToVerify(params) {
        return http.get('/users/updatesToVerify', { params });
    }

    getUsersToVerify(params) {
        return http.get('/users/toVerify', { params });
    }

    getSearchBy(params) {
        return http.post('/users/searchBy', params);
    }

    getAllQrIndexToCheck(params) {
        return http.post('/users/checkQrIndex',  params);
    }

    setQrIndexCheck(params) {
        return http.post(`/users/setQrIndexChecked`, params);
    }

    getAllEventUsersToCheck(params) {
        return http.post('/users/checkEventUsers',  params);
    }

    setEventUserCheck(params) {
        return http.post(`/users/setEventUserCheck`, params);
    }

    getByEmail(params) {
        return http.post('/users/searchByEmail', params)
    }

    get(id) {
        return http.get(`/users/${id}`);
    }

    getMedia(id) {
        return http.get(`/users/${id}/media`);
    }

    getTokens(id) {
        return http.get(`/users/${id}/tokens`);
    }

    getNotifications(id) {
        return http.get(`/users/${id}/notifications`);
    }

    getSocial(id) {
        return http.get(`/users/${id}/social`);
    }

    getDescription(id) {
        return http.get(`/users/${id}/description`);
    }

    getPedigree(id, params) {
        return http.post(`/users/${id}/history`, params);
    }

    getActionsGenerator(id, params) {
        return http.post(`/users/${id}/generator`, params);
    }

    getUserPacks(id) {
        return http.get(`/users/${id}/packs`);
    }

    deleteToken(id, token) {
        return new Promise.reject(new Error(`deleteToken ${token} for Id ${id} not implemented`))
    }

    checkUser(id, params) {
        return http.post(`/users/${id}/markAsChecked`, params)
    }

    checkedUserUpdate(documentId, params) {
        return http.post(`/users/${documentId}/updateChecked`, params)
    }

    getSubscriptions(id) {
        return http.get(`/users/${id}/subscriptions`);
    }

    getPayments(id) {
        return http.get(`/users/${id}/payments`);
    }

    getPacks(id) {
        return http.get(`/users/${id}/packs`);
    }

    getCreditsActions(id) {
        return http.get(`/users/${id}/actions`);
    }

    sendNotification (id, params) {
        return http.post(`/users/${id}/sendNotification`, params)
    }

    updateMarketing (id, params) {
        return http.post(`/users/${id}/updateMarketingSex`, params)
    }

    getModerationProfiles(params) {
        return http.post(`/users/moderation-profiles`, params);
    }

    getModerationUpdates(params) {
        return http.post(`/users/moderation-updates`, params);
    }

    hasActiveSubscription(userId) {
        return http.get(`/users/${userId}/checkActiveSubscription`);
    }
}

export default new UsersDataService();
